<div *ngIf="bookingDetails" class="booking-popup custom-popup" outSideClick
  (outSideClick)="closeSummaryModalOnOutSideClick()">
  <div class="details-heading common-flex-between">
    <div class="booking-p">
      <h3>Ticket</h3>
      <div class="booking-detailss">
        <p>
          <span>{{bookingDetails?.driverName}} - </span><span
            class="custom-number">{{bookingDetails?.driverMobile}}</span>
        </p>

      </div>
    </div>
    <em class="pi pi-times" (click)="cancelDialog()"></em>
  </div>

  <div class="booking-slot-status common-flex-between">
    <div *ngIf="bookingDetails?.status" class="common-line" [ngClass]="{
      'pstatus-in-progress': bookingDetails?.status === 'In Progress' || bookingDetails?.status === 'Upcoming',
      'pstatus-completed': bookingDetails?.status === 'Completed',
      'pstatus-pending': bookingDetails?.status === 'Pending',
      'pstatus-cancel': bookingDetails?.status === 'Cancelled',
      'pstatus-Partial': bookingDetails?.status === 'Partially Cancelled'
      }">
      {{bookingDetails?.status}} <span
        *ngIf="bookingDetails?.status== 'Cancelled' && bookingDetails?.paymentFailureError === null && paymentInfo"
        class="refunds">-
        {{paymentInfo}}</span><span *ngIf="bookingDetails?.paymentFailureError" class="refunds">-
        {{bookingDetails?.paymentFailureError}}</span></div>
    <div class="btn-sloat">
      <p>Slot - {{bookingDetails?.parkingSlot}}</p>
    </div>
  </div>
  <div class="row-divider custom-text">
    <div class="booking-address">
      <h3>{{bookingDetails?.parkingArea}}</h3>
      <p>{{bookingDetails?.address}}</p>
    </div>
    <div class="booking-details">
      <h3>{{bookingDetails?.vehicleType}} <span
          *ngIf="bookingDetails?.vehicleInformation">({{bookingDetails?.vehicleInformation}})</span> </h3>
    </div>
  </div>
  <div class="blue-strips">
    <div class="hrs-outer common-flex-between">
      <p>{{bookingDetails?.duration}} {{arrival | date: 'MMM d, y'}} <span>-
          {{departure | date: 'MMM d, y'}}</span></p>
      <p *ngIf="bookingDetails?.discount > 0">Discounted - ${{bookingDetails?.discount}}</p>
    </div>

    <div class="timer-main common-flex-between">
      <div class="left-timer ">
        <ul>
          <li>
            <h4>
              {{bookingDetails?.enterTimeIst}}
            </h4>
            <p>Start Time</p>
          </li>
          <li><em class="pi pi-arrow-right" style="font-size: 2rem"></em></li>
          <li>
            <h4>
              {{bookingDetails?.exitTimeIst}}
            </h4>
            <p>Exit Before</p>
          </li>
        </ul>
      </div>
      <div class="time-outer paid-outer" [ngSwitch]="paymentStatus">
        <div
          [ngClass]="[(bookingDetails?.paymentStatus | PaymentStatusClass),shouldShowDisputeMessage(bookingDetails?.paymentStatus) ? 'pstatus-disputed' : '']">
          <h5>
            <img [src]="getStatusImage(bookingDetails?.paymentStatus)" alt="" />
            <span>{{ bookingDetails?.bookingStatus?.label }}</span>
          </h5>
        </div>
        <p><span
            [ngClass]="{ 'proposer': paymentStatus === 1 || paymentStatus === 4, 'failed-amt': paymentStatus === 5 }"
            class="paid-number">${{bookingDetails?.total}}</span> <span class="after-user-credit"><del
              *ngIf="bookingDetails?.usedCredit>0">${{bookingDetails?.usedCredit + bookingDetails?.total | number:
              '1.2-2'}}</del></span></p>
      </div>
    </div>
  </div>
  <div *ngIf="role === 'Driver'">
    <div class="QR-img">
      <img *ngIf="bookingDetails?.companyLogo; else defaultImage" [src]="bookingDetails?.companyLogo" alt="QR code" />
      <ng-template #defaultImage>
        <img src="../../../../assets/images/Ticket Detail.png" alt="Static" />
      </ng-template>
    </div>

    <div *ngIf="bookingDetails?.isOpenGateIntegarted; else showAccessCode">
      <div class="open-gatetext">
        <h5 *ngIf="openGatePass( bookingDetails) !== 'dash'; else noAccessCode">
          <a [ngClass]="{'greyout-link': openGatePass(bookingDetails) === 'greyout'}" href="#"
            (click)="openGatePass(bookingDetails) !== 'greyout' ? openTruckCheckOutUrl($event,bookingDetails?.truckCheckOutUrl) : null">
            {{ 'Open-Gate' }}
          </a>
        </h5>
        <ng-template #noAccessCode>
          <h5>-</h5>
        </ng-template>
      </div>
    </div>

    <ng-template #showAccessCode>
      <div>
        <ng-container *ngIf="openGatePass(bookingDetails) as gatePass">
          <div class="access-code" *ngIf="(gatePass !== 'dash' && gatePass !== 'greyout'); else showDash">
            <span>Access code: </span>{{ bookingDetails?.accessCode}}
          </div>
        </ng-container>
        <ng-template #showDash>
          <div class="access-code">
            <p>Access Code Unavailable</p>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
  <div *ngIf="role !== 'Driver'">
    <div class="popup-overright">
      <div class="blank-popup popup-img"
        *ngIf="(bookingDetails?.parkingLayout && !bookingDetails?.isParkingLotLayoutDoc); else alternativeDiv">
        <img [src]="bookingDetails?.parkingLayout" alt="Layout" />
      </div>
    </div>

    <ng-template #alternativeDiv>
      <div class="blank-img">
        <p *ngIf="!bookingDetails?.isParkingLotLayoutDoc; else viewDocument">No Parking Plan Avaliable</p>
      </div>
    </ng-template>

    <ng-template #viewDocument>
      <p>
        <a [href]="bookingDetails?.parkingLayout" target="_blank">
          <span>View Document</span>
        </a>
      </p>
    </ng-template>
  </div>
</div>